<template>
  <div>
    <ul class="grid grid-cols-1 md:grid-cols-4 gap-x-16 gap-y-12">
      <li
        v-for="(link, index) in links"
        v-show="index < maxVisibleLinks || showAll"
        :key="link.label"
      >
        <RevLink
          class="body-2 transition-colors hover:text-action-default-hi"
          :to="link.url"
          :underlined="false"
          @click.prevent="
            emit('link-click', { label: link.label, position: index + 1 })
          "
        >
          {{ link.label }}
        </RevLink>
      </li>
      <li v-if="!showAll && links.length > maxVisibleLinks">
        <button
          class="body-2-bold transition-colors hover:text-static-default-hi"
          type="button"
          @click="showAll = true"
        >
          {{ seeMoreLabel }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import { useClientOnlyComputedBreakpoint } from '@backmarket/utils/composables/useClientOnlyComputedBreakpoint'
import { Breakpoint } from '@backmarket/utils/dom/getCurrentBreakpoint'
import { RevLink } from '@ds/components/Link'

import type { SeoLink } from './SeoFooterLinks.types'

withDefaults(
  defineProps<{
    links: SeoLink[]
    seeMoreLabel?: string
  }>(),
  {
    seeMoreLabel: 'See more',
  },
)

const emit = defineEmits<{
  (e: 'link-click', product: { label: string; position: number }): void
}>()

const breakpoint = useClientOnlyComputedBreakpoint()
const maxVisibleLinks = computed(() =>
  breakpoint.value >= Breakpoint.MD ? 39 : 9,
)

const showAll = ref(false)
</script>
